import { BsCaretDownFill, BsCaretUpFill } from "react-icons/bs";
import { FiTrash2 } from "react-icons/fi";
import logoImage from "../../images/b.png";
import DarklogoImage from "../../components/navigation/d.png";
import { BiChevronsRight, BiSun, BiMoon } from "react-icons/bi";
import { MdLanguage } from "react-icons/md";
import { Link } from "react-router-dom";
import { useCart, useCartDispatcher } from "../../context/CartProvider";
import i18next from "i18next";

const CartPage = ({ changeLanguage, theme, setTheme }) => {
  const { cart, totalPrice } = useCart();
  console.log(cart.length);
  const dispatch = useCartDispatcher();
  const RemoveHandler = (product) => {
    dispatch({ type: "REMOVE_PRODUCT", payload: product });
  };
  const DecreaseHandler = (product) => {
    dispatch({ type: "DECREASE_PRODUCT", payload: product });
  };

  const IncreaseHandler = (product) => {
    dispatch({ type: "ADD-TO-CART", payload: product });
  };

  return (
    <div className="dark:bg-Darkscreen bg-lightscreen dark:text-white text-Darktext h-[1500px]">
      <nav>
        <div className="flex flex-row justify-between pt-[10px] ">
          <div className="mx-10 flex flex-row justify-between text-[22px] w-full dark:text-white text-thertext ">
            <div className=" pb-2 ">
              {theme === "lightTheme" ? (
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    setTheme("darkTheme");
                  }}
                  className="cursor-pointer "
                >
                  <BiMoon className="inline" />
                </span>
              ) : (
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    setTheme("lightTheme");
                  }}
                  className="cursor-pointer "
                >
                  <BiSun className="inline" />
                </span>
              )}
            </div>
            <div onClick={() => changeLanguage()}>
              {i18next.language === "fa" ? (
                <span className="text-[15px] font-semibold">En</span>
              ) : (
                <span className="text-[15px] font-semibold">فا</span>
              )}

              <MdLanguage className="inline" />
            </div>
          </div>
        </div>
        <div className="flex flex-col mt-5 self-center">
          <div className="self-center mb-2">
            <Link to={"/"}>
              <img
                src={theme === "lightTheme" ? logoImage : DarklogoImage}
                alt=""
                onClick={(e) => {}}
              />
            </Link>{" "}
          </div>
        </div>
      </nav>

      <div className="my-6 mx-10 mx:ml-16 ">
        <div className="text-white md:mx-5 mt-5 mb-8 flex ">
          <Link
            to={"/"}
            className="dark:text-[#717374] text-thertext mr-1 self-center"
          >
            Home
          </Link>
          <span className="self-center dark:text-[#717374] text-thertext mr-1  ">
            <BiChevronsRight />
          </span>
          <span className="text-[21px] font-semibold text-btnMain ">
            Your Shopping Cart
          </span>
        </div>
      </div>
      <div className="flex justify-center">
        <div className="w-full">
          <div className="flex md:flex-row flex-col justify-center mx-5 ">
            <div className="md:w-[65%] bg-white dark:bg-Darksecondcolor p-5 rounded-l-md">
              <div className="flex flex-col">
                <div className="flex  justify-between mr-5 border-b border-slate-300 ">
                  <div className="dark:text-[#c6c7c7] text-thertext ">
                    <p>Items</p>
                  </div>
                </div>
                <div
                  className="md:max-h-[500px] md:overflow-y-scroll md:pr-16 w-full
                  md:scrollbar dark:scrollbar-track-[#282a2c] scrollbar-track-secondtext dark:scrollbar-thumb-[#64778a] scrollbar-thumb-Darksecondtext scrollbar-track-rounded-sm  scrollbar-thumb-rounded-sm                           "
                >
                  {cart.length === 0 ? (
                    <div className="flex flex-col">
                      <div className="self-center mt-4 text-btnMain text-[18px] font-semibold">
                        Your Cart empty
                      </div>
                      <div className="self-center mt-8">
                        <div>
                          <Link to={"/"}>
                            <button className=" bg-btnMain text-white px-4 py-3 rounded-md">
                              CONTINUE SHOPPING
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ) : (
                    cart.map((item) => (
                      <div className="flex justify-between py-8 border-b-2 dark:border-[#353535] w-full ">
                        <div className="flex w-full">
                          <div className="max-w-[170px] min-w-[90px]  md:mx-4 ">
                            <img src={item.image} alt="" />
                          </div>
                          <div className="flex flex-col mt-4 mx-2 ">
                            <div className="mb-2 text-Darktext dark:text-white text-[16px] y9:text-[20px]">
                              <p className="font-bold">{item.title}</p>
                            </div>
                            <div className="dark:text-[#c6c7c7] text-thertext">
                              <p>{item.Author}</p>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-end w-full mt-4 ">
                          <div className="flex flex-col h-[62px] mr-3 border border-[#c6c7c7] rounded-md px-2 py-[1px]">
                            <div
                              className="self-center text-btnMain text-[18px]"
                              onClick={() => IncreaseHandler(item)}
                            >
                              <BsCaretUpFill />{" "}
                            </div>
                            <div className="self-center">{item.quantity}</div>
                            <div
                              className="self-center dark:text-[#c6c7c7] text-slate-400 text-[18px]"
                              onClick={() => DecreaseHandler(item)}
                            >
                              {" "}
                              <BsCaretDownFill />{" "}
                            </div>
                          </div>
                          <div className="mr-3 mt-3">
                            <p>${item.price.toFixed(2) * item.quantity}</p>
                          </div>
                          <div
                            className="mt-4 text-red-500 text-[20px] "
                            onClick={() => RemoveHandler(item)}
                          >
                            {" "}
                            <FiTrash2 className="self-center" />{" "}
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
            <div
              className="flex mt-5 md:mt-0
            md:h-[350px] h-[200px] md:ml-1 
            justify-start md:justify-center pl-8 md:border-l-2 bg-white dark:bg-Darksecondcolor p-5 md:rounded-r-md dark:border-[#353535]"
            >
              <div className="flex flex-col w-full md:w-64 justify-between">
                <div>
                  <div className="text-[20px] mb-6">Total</div>
                  <div>
                    <div className="flex justify-between">
                      <p>Total price : </p>
                      <p className="ml-2 text-[20px] font-semibold text-btnMain">
                        ${totalPrice.toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="flex justify-center">
                    <button className="bg-btnMain w-[70%] md:w-full hover:bg-blue-700 duration-200 text-white  py-2 rounded-md">
                      Check Out
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
